import NotFound from 'common/NotFound';
import useFullPageLoader from 'common/UseFullPageLoader';
import React, { useEffect, useState } from 'react'
import { Pagination } from 'react-bootstrap';
import { RiAdminLine } from 'react-icons/ri';
import { useSearchParams } from 'react-router-dom';
import { subAdminListApi } from 'services/subAdmin';
import findSerialNumber from 'utils/findSerialNumber';
import UpdatePassword from './UpdatePassword';

const SubAdminList = () => {
    const [loader, onShow, onHide] = useFullPageLoader();
    const [subAdmin, setSubAdmin] = useState([])
    const [selectedData, setSelectedData] = useState({ modal: false })
    //------------sub-admin-list------------
    const fetchSubAdminList = async () => {
        onShow();
        try {
            const res = await subAdminListApi();
            const { code, data } = res?.data;
            if (code === 200) {
                setSubAdmin(data || [])
            }
        } catch (error) {
            console.log(error);
        } finally {
            onHide();
        }
    };

    useEffect(() => {
        fetchSubAdminList();
    }, []);
    // -----------handle-change-password-----------
    const handleChangePassword = (data) => {
        setSelectedData({ ...data, modal: true })
    }
    return (
        <div className="user-management-container">
            <div className="page_title has_child">
                <h3>Sub Admin Management</h3>
            </div>
            {/* ---------card */}
            <div className="card">
                {loader}
                <div className="table-container">
                    <table className="table custom_table">
                        <thead>
                            <tr>

                                <th className="nowrap text-center">Sub-Admin Name</th>
                                <th className="nowrap text-center">Email</th>
                                <th className="nowrap text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {subAdmin.length > 0 ? (
                                subAdmin?.map((data, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="nowrap text-center">
                                                {data?.name || "Admin"}
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.email || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                <button
                                                    type="button mt-1"
                                                    className="button"
                                                    onClick={() => handleChangePassword(data)}
                                                >
                                                    Change password
                                                </button>
                                            </td>

                                        </tr>
                                    );
                                })
                            ) : (
                                <NotFound
                                    cols={5}
                                    msg={"Sub Admin not found"}
                                    onHide={onHide}
                                    icon={<RiAdminLine />}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* ---------change-status------------------- */}
            <UpdatePassword
                show={selectedData?.modal}
                close={() => setSelectedData((prev) => ({ ...prev, modal: false }))}
                listing={fetchSubAdminList}
                selectedData={selectedData}
            />

        </div>
    )
}

export default SubAdminList